import { __ } from "src/libs/utilities"
import { useUser } from "src/settings/zustand/user"

/* Protopia Ecosystem component */ 
const VirtualUserWidget = (): JSX.Element | null => {
    const user = useUser()
    return user.display_name !== "Anonym User-2"
        ?
        <div className='small flex-centered mx-3' data-testid="virtual-user-widget">
            <span className=" fas fa-user mr-2" />
            <div className=" letter-spacing-1" data-testid="virtual-user-name">
                {user.display_name}
            </div> 
        </div>
        :
        <>...</>
}
export default VirtualUserWidget